import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import './camera.css';
import {setImage, setShowError, setErrorType } from "../../redux/actionCreators";
import cameraProcess from "../../library/CameraProcess";
import { connect } from "react-redux";


class Camera extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        cameraProcess.initCamera(this.error, this.video, this.canvasVideo, this.shadow);
    }

    error = (error) => {
        alert('ha ocurrido un error:'  + error);
        console.log(error);
    };

    play = async () => {
        await cameraProcess.play(this.video, this.canvasVideo);
    };

    capture = async() => {
        console.log(await cameraProcess.capture(this.video));
    };

    frontalCamera = async () => {
        cameraProcess.initCamera(this.error, this.video, this.canvasVideo, this.shadow, cameraProcess.FACING_MODE_USER);
        this.play();
    };

    backCamera = async () => {
        cameraProcess.initCamera(this.error, this.video, this.canvasVideo, this.shadow, cameraProcess.FACING_MODE_ENVIRONMENT);
        this.play();
    };

    render() {
        return (
            <div className={'camera'}>
                <canvas
                    ref={canvasVideo => this.canvasVideo = canvasVideo}
                    className={'canvas-video'}
                />
                <div className={"shadow"} ref={shadow => this.shadow = shadow} />
                <video
                    playsinline={'true'}
                    webkit-playsinline={'true'}
                    ref={video => this.video = video}
                    className={'video'}
                />
                <div className="config-button">
                    <Button onClick={this.frontalCamera}>Frontal</Button>
                    <Button onClick={this.backCamera}>Trasera</Button>
                    <Button onClick={this.play}>Play</Button>
                </div>
                <Button className={'capture-button'} onClick={this.capture}/>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        component: state.component,
        image: state.image,
        showError: state.showError,
        setErrorType: state.setErrorType,
        stepInfo: state.stepInfo
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setImage(image) {
            dispatch(setImage(image));
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Camera);
